import { useEffect } from 'react';
import Step_Zero from '../../component/Step_Zero';
import './style.scss';

const StepZero = () => {
  useEffect(() => {
    window.document.title =
      '';
  }, []);
  return (
    <div className="step_zero_page_wrapper">
      <Step_Zero />
    </div>
  );
};

export default StepZero;
